// Module
var code = `<div><div class="world"><network-map event-id="eventId" show-events="showEvents"></network-map></div></div><onboarding-dialog-modal ng-if="showWelcomeModal || missingRequiredStudentNetworkEmail" dismiss="ensureWelcomeFlagSaved()"></onboarding-dialog-modal>`;
// Exports
export default code;